import React, { createContext, useContext, useState, useEffect } from 'react';

const BaseURLContext = createContext();

export const BaseURLProvider = ({ children }) => {
    const [baseURL, setBaseURL] = useState('');

    useEffect(() => {
        const currentHostname = window.location.hostname;
        console.log(currentHostname);
        setBaseURL(currentHostname);
    }, []);

    return (
        <BaseURLContext.Provider value={baseURL}>
            {children}
        </BaseURLContext.Provider>
    );
};

export const useBaseURL = () => useContext(BaseURLContext);
